var TransitionGateType = /* @__PURE__ */ ((TransitionGateType2) => {
  TransitionGateType2["StartTrafficByFlight"] = "StartTrafficByFlight";
  TransitionGateType2["AdvanceTrafficByFlight"] = "AdvanceTrafficByFlight";
  TransitionGateType2["StartAndAdvanceTrafficByFlight"] = "StartAndAdvanceTrafficByFlight";
  return TransitionGateType2;
})(TransitionGateType || {});
export {
  TransitionGateType
};
//# sourceMappingURL=GatingUtils.types.js.map
